import m from "mithril";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import i18n from "../../../shared/i18n/i18n";
import Toasts from "../../../shared/toasts";
import ModalManager from "../../../shared/modal";
import Modal_Confirm_Delete from "../../../shared/components/modal_confirm_delete";
import Auth from "../../../shared/auth";
import FormUtilities from '../../../shared/utilities/form_utilities';
import RouterService from "../../../shared/services/router.service";
import {getUnitActiveStatusSlider} from "../unit_status_slider_util";
import {loadCourses} from "../unit_courses";
import TextEditor from "../../../shared/components/component_text_editor";

let saving, deleting, unit;
let onCoursesClick;

function saveUnitDetails() {
    if (!FormUtilities.validateFields(".details input")) {
        return;
    }

    saving = true;
    Requester.post(Gateway.admin + "units/form/" + unit.id, {
        id: unit.id,
        name: unit.name,
        description: unit.description,
        instructions: unit.instructions
    })
        .then(function (result) {
            Toasts.add("success", i18n.t("saved_changes"));
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .then(function () {
            saving = false;
        });
}

function confirmDeleteUnit() {
    ModalManager.open(i18n.t("delete_unit"), [], Modal_Confirm_Delete, {callback: deleteUnit});
}

function deleteUnit() {
    deleting = true;
    Requester.delete(Gateway.admin + "units/form/" + unit.id)
        .then(function () {
            RouterService.navigateToUnits();
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            deleting = false;
        });
}

const Component_Unit_Form_Settings = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
        onCoursesClick = vnode.attrs.onCoursesClick;
        loadCourses(unit.id);
    },
    view: function () {
        return [
            m(".content-box", [
                m(".h3", i18n.t("details")),
                m(".form .details", {class: !Auth.validateRights(["unit_form_edit"]) ? "disabled" : ""}, [
                    m(".form-section required", [
                        m(".form-label", i18n.t("name")),
                        m("input[type=text]", {
                            oninput: function () {
                                unit.name = this.value;
                            }, value: unit.name
                        })
                    ]),
                    m(".form-section", [
                        m(".form-label", i18n.t("description_not_visible_to_learners")),
                        m("textarea", {
                            oninput: function () {
                                unit.description = this.value;
                            }, value: unit.description
                        })
                    ]),
                    m(".form-section", [
                        m(".form-label", i18n.t("instructions_will_appear_for_learners")),
                        m(TextEditor, {
                            content: encodeURIComponent(unit.instructions || ""),
                            hideHyperlink: true,
                            onchange: function (content) {
                                unit.instructions = content;
                            }
                        })
                    ]),
                    Auth.validateRights(["unit_form_edit"], [
                        m(".form-buttons", [
                            saving
                                ? m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                                : !!unit.name
                                    ? m("button", {onclick: saveUnitDetails}, i18n.t("save"))
                                    : m("button.btn-text no-click", i18n.t("save"))
                        ])
                    ])
                ])
            ]),
            m(".content-box", [
                m(".form", {class: !Auth.validateRights(["unit_form_edit"]) ? "disabled" : ""}, [
                    getUnitActiveStatusSlider(unit, saving, onCoursesClick)
                ])
            ]),
            Auth.validateRights(["unit_form_delete"], [
                m(".content-box", [
                    !deleting ? m("button.btn-error", {onclick: confirmDeleteUnit}, i18n.t("delete_unit")) : m("button.btn-text no-click text-error", [i18n.t("deleting"), m(".loading-dots")])
                ])
            ])
        ];
    }
};
export default Component_Unit_Form_Settings;
